<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/msJSPs/tc-custom/9781429993036.jpg?1731797221239" alt="This image is the cover for the book Curse-Maker, Arcturus"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Curse-Maker, Arcturus
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The Curse-Maker </i>is the sequel to he award-winning <i>Nox Dormienda, </i>the first book of the Roman noir series created by Kelli Stanley (<i>City of Dragons</i>). Wedding impeccably researched history to prose and themes reminiscent of classic hard-boiled writers, <i>The Curse-Maker</i> is a thrilling and suspenseful journey into a dark corner of Roman Britain you've never seen before.<br/><br/>When Roman physician Arcturus and his stunning wife, Gwyna, arrive at Bath for a holiday, a dead body is floating in the sacred spring. It turns out that the murdered man is a curse-maker whose invocations actually come true, and as murder follows murder, it looks like there's now a curse on Arcturus. <br/><br/>This is an exciting and exotic story of a spa town where people go to heal...only to wind up dead. And it takes the doctor-investigator on a dark road -- into Roman cemeteries, silver mines, and underground water tunnels -- to comprehend the twisted mind of a killer bent on revenge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelli Stanley
      </h2>
      
      <p class="authorDescription body article"><P>KELLI STANLEY's first novel in the 1940 San Francisco-set Miranda Corbie series, CITY OF DRAGONS, was met with overwhelming critical acclaim and was a finalist for the prestigious Los Angeles Times Book Prize. Stanley also writes a highly-praised series set in Roman Britain, the latest of which is THE CURSE-MAKER. Her debut novel, NOX DORMIENDA, won the Bruce Alexander Award for best historical mystery of 2008. She makes her home in Dashiell Hammett's San Francisco, earned a Master's Degree in Classics, and loves jazz, old movies, fedoras, Art Deco and speakeasies.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?481f2119